<template>
  <BaseScreen v-bind="screen">
    <BaseAlert
      v-if="isErrorVisible"
      v-bind="error"
      slot="middle"
    />
    <Camera
      v-if="isMultipleFaces"
      :label="cameraLabel"
      @click="onCameraTouch"
    />
    <BaseForm
      v-if="isFaceUnknown"
      ref="form"
      v-bind="form"
      class="screen__form"
      data-animation="fadeInBottom"
      @submit="onFormSubmit"
    />
  </BaseScreen>
</template>

<script>
import CONSTANTS from '@/helpers/constants';

import screenMixin from '@/mixins/screen';
import cameraMixin from '@/mixins/camera';
import faceMixin from '@/mixins/face';
import formMixin from '@/mixins/form';

import Camera from '@/components/Camera.vue';

export default {
  name: 'FindFaceScreen',
  mixins: [screenMixin, cameraMixin, faceMixin, formMixin],
  components: {
    Camera,
  },
  data() {
    return {
      isMultipleFaces: false,
      isCameraStarted: false,
      isFaceUnknown: false,
      currentFace: null,
      values: {
        name: '',
      },
    };
  },
  computed: {
    titleText() {
      return this.isFaceUnknown ? this.$t('titles.whatIsYourName') : '';
    },
    pendingText() {
      if (this.isMultipleFaces && !this.isCameraStarted) {
        return this.$t('pending.hardware');
      }
      if (!this.currentFace) {
        return this.$t('pending.recognize');
      }
      return this.$t('pending.operation');
    },
    screenCase() {
      if (this.isErrorVisible) {
        return CONSTANTS.STEP_HARDWARE_ERROR;
      }
      if (this.isFaceUnknown) {
        return CONSTANTS.STEP_MEET;
      }
      if (this.isCameraStarted) {
        return CONSTANTS.STEP_FACE;
      }
      return null;
    },
    cameraLabel() {
      return this.$t('actions.pickYourself');
    },
    form() {
      return {
        values: this.values,
        fields: [
          {
            name: 'name',
            type: 'text',
            label: this.$t('fields.nameLabel'),
            placeholder: this.$t('fields.namePlaceholder'),
            errorMessage: this.$t('fields.nameError'),
            required: true,
          },
        ],
        actions: [
          {
            type: 'submit',
            text: this.$t('actions.continue'),
          },
        ],
      };
    },
    error() {
      return {
        icon: {
          name: 'important',
          theme: 'secondary',
          size: 'l',
        },
        title: {
          text: this.$t('titles.badHardware'),
        },
        description: {
          text: this.$t('texts.temperatureMeasureNotPossible'),
        },
        actions: [
          {
            text: this.$t('actions.home'),
            action: this.goToHomeScreen,
            view: 'outlined',
          },
        ],
      };
    },
  },
  methods: {
    onCameraStart() {
      this.isCameraStarted = true;
      this.hidePending();
    },
    onCameraTouch(e) {
      const coordinates = {
        x: e.offsetX / e.target.clientWidth,
        y: e.offsetY / e.target.clientHeight,
      };
      return this.pickFaceByCoordinates(coordinates); // функция из миксина
    },
    onCameraError() {
      // Этот колбек будет вызван из миксина, если прилетит ошибка камеры
      this.showError();
    },
    onMultipleFaces() {
      // Этот колбек будет вызван из миксина, если в кадре несколько лиц
      this.isMultipleFaces = true;
      this.showPending(0);
      this.startCamera(true);
    },
    onRecognizeStart() {
      this.showPending();
    },
    onGeneralFaceSetted(face, isFaceUnknown) {
      // Этот колбек будет вызван из миксина после установки главного лица
      this.isMultipleFaces = false;
      this.hidePending();
      if (isFaceUnknown) {
        this.isFaceUnknown = true;
        this.currentFace = face;
        this.$nextTick(this.setFieldFocus); // функция из миксина
      } else {
        this.goToTemperatureScreen(face.id);
      }
    },
    async onFormSubmit() {
      if (this.isPending) return;
      try {
        this.showPending();
        const { name } = this.values;
        const face = await this.addNewFace(this.currentFace, name); // функция из миксина
        this.goToTemperatureScreen(face.id);
      } catch (e) {
        console.error('onFormSubmit error: ', e);
        this.showError();
      }
    },
    goToTemperatureScreen(id) {
      return this.$router.push({
        path: this.$router.options.paths.temperature,
        query: { id },
      });
    },
  },
};
</script>
